<template>
  <div>
    <h3>Graduate: {{ graduate.name }}</h3>

    <div class="card">
      <div class="card-header">
        <a class data-toggle="collapse" href="#collapseDirections" role="button" aria-expanded="false" aria-controls="collapseDirections">
          <div class="row">
            <div class="col">
              <h3 class="card-header-title">
                <font-awesome :icon="['far', 'info-circle']" class="text-muted mr-2"/> Directions
              </h3>
            </div>

            <div class="col-auto">
              <span class="collapse-marker">
                Hide / Show
                <font-awesome :icon="['fas', 'chevron-down']"/>
              </span>
            </div>
          </div><!-- /.row -->
        </a>
      </div>
      <div class="collapse show" id="collapseDirections">
        <div class="card-body card-body-info">
          <p>Please complete the following for each objective:</p>
          <ul>
            <li>Indicate if met or not met</li>
            <li>Provide commentary on what was achieved by the graduate, what worked well and any challenges faced.</li>
          </ul>

          <p>The graduate will be notified to review your commentary and assessment once you have signed off their plan.</p>
        </div>
      </div><!-- /.collapse -->
    </div><!-- /.card -->

    <h2 class="mt-5">Performance Objective Outcomes</h2>
    <placements-end-component-performance-item v-for="(objective, index) in objectives" :objective="objective" :objective-index="index" :key="objective.id"/>

    <div class="alert alert-danger" v-if="otherErrors.length > 0">
      <p>All fields must be filled before proceeding to the next step. Check above for missing data.</p>
    </div>

    <div class="save-actions">
      <div class="text-right">
        <router-link :to="{ name: 'graduates.placements.single', params: { placementId: placement.id, graduateId: placement.graduate_id } }" class="btn btn-link btn-discard mr-2">Discard &amp; Exit</router-link>
        <ladda-button :validate="false" class="btn btn-outline-dark mr-2" :click="handleSaveAndExit" :failed="failed">Save &amp; Exit</ladda-button>
        <ladda-button :validate="false" class="btn btn-success" :click="handleNext" :failed="failed">Next</ladda-button>
      </div>
    </div><!-- /.save-actions -->
  </div>
</template>

<script>
import { placementPerformanceObjectiveComputed, placementPerformanceObjectiveMethods, placementComputed, placementMethods, graduateComputed } from 'vx/helpers'
import { populateObjectiveServerErrors } from './PlacementsStartComponentPerformance'
import PlacementsEndComponentPerformanceItem from './PlacementsEndComponentPerformanceItem'

export default {
  components: {
    PlacementsEndComponentPerformanceItem
  },

  data () {
    return {
      otherErrors: []
    }
  },

  computed: {
    ...placementPerformanceObjectiveComputed,
    ...placementComputed,
    ...graduateComputed
  },

  async created () {
    await this.getPerformanceObjectives()
  },

  methods: {
    ...placementPerformanceObjectiveMethods,
    ...placementMethods,

    async handleNext () {
      let payload = {
        objectives: this.objectives,
        draft: false
      }

      await this.updateEndPerformanceObjectives(payload)

      this.$router.push({ name: 'placements.single.end.manager.capabilities', params: { placementId: this.placement.id, graduateId: this.placement.graduate_id } })
      this.setPlacementProperty({ property: 'end_component.performance_objectives_completed', value: true })
      this.$validator.reset()
      this.$noty.success('Performance objective outcomes saved')
    },

    async handleSaveAndExit () {
      let payload = {
        objectives: this.objectives,
        draft: true
      }

      await this.updateEndPerformanceObjectives(payload)
      this.$validator.reset()
      this.$router.push({ name: 'graduates.placements.single', params: { placementId: this.placement.id, graduateId: this.placement.graduate_id } })
    },

    failed (error) {
      if (error.response && error.response.status === 422) {
        this.populateObjectiveServerErrors(error.response)
      }
    },

    populateObjectiveServerErrors
  }
}
</script>
